var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWbtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0c11.043 0 20 8.954 20 20 0 11.043-8.957 20-20 20C8.954 40 0 31.043 0 20 0 8.954 8.954 0 20 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m32.615 8.394-1.097 1.099a15.55 15.55 0 0 1 0 20.986l1.097 1.097c6.044-6.555 6.044-16.651 0-23.207v.025Zm-23.1.096c5.94-5.432 15.044-5.432 20.986 0l1.097-1.097c-6.556-6.047-16.653-6.047-23.207 0L9.514 8.49ZM8.49 30.488c-5.426-5.938-5.426-15.034 0-20.974L7.393 8.417c-6.047 6.556-6.047 16.652 0 23.205l1.097-1.134Zm21.998 1.014a15.543 15.543 0 0 1-20.983 0l-1.1 1.1c6.555 6.044 16.653 6.044 23.208 0l-1.125-1.1Z",
    fill: "#5A5564"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.328 17.203c0 2.196-3.434 1.93-4.526 1.93v-3.87c1.092 0 4.526-.343 4.526 1.94Zm.896 6.008c0 2.4-4.114 2.126-5.426 2.126v-4.26c1.312.002 5.426-.374 5.426 2.134Zm2.71-6.876c-.22-2.292-2.196-3.06-4.697-3.296V9.88h-1.932v3.097c-.51 0-1.028 0-1.547.017V9.881h-1.921v3.177H12.92v2.069s1.429-.025 1.406 0a1.002 1.002 0 0 1 1.098.85v8.702a.7.7 0 0 1-.232.474.71.71 0 0 1-.5.168c.023.02-1.405 0-1.405 0l-.385 2.309h3.901v3.23h1.935v-3.182h1.543v3.165h1.937v-3.19c3.267-.2 5.543-1.004 5.829-4.062.23-2.46-.926-3.558-2.775-4.001 1.125-.572 1.83-1.579 1.662-3.255",
    fill: "#F09242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.997 1.56C9.819 1.566 1.576 9.817 1.577 19.994 1.58 30.17 9.83 38.417 20.005 38.417c10.176.002 18.428-8.246 18.432-18.422C38.423 9.82 30.174 1.573 19.994 1.57V1.56h.003Zm0 38.44C8.952 39.998-.003 31.043 0 20 0 8.953 8.954 0 19.998 0s20 8.952 20.002 19.995C39.989 31.04 31.038 39.99 19.997 40Z",
    fill: "#282138"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbtc);
export default __webpack_public_path__ + "static/media/wbtc.8330ef8dcf4d6959a9eae73545da71c9.svg";
export { ForwardRef as ReactComponent };